import { useCallback } from "react";

import type { LeadsColumnsConfigDto, LeadsSearchColumnListConfig } from "app/pages/sales-intelligence/modules/leads-search";

import { fromLeadsConfigDtoToColumnOptions } from "../../../leads-search/utils";

import { useColumnsConfigQuery } from "./useColumnsConfigQuery";

export const useColumnsConfigOptionsQuery = (columnConfig: LeadsSearchColumnListConfig) => {
    const transformData = useCallback(
        (data: LeadsColumnsConfigDto) => fromLeadsConfigDtoToColumnOptions(data, columnConfig),
        [columnConfig],
    );

    return useColumnsConfigQuery(transformData);
};
